// extracted by mini-css-extract-plugin
module.exports = {"ArticleDate":"ArticleDate_ArticleDate__NIJDx","ArticleUpdatedDate":"ArticleDate_ArticleUpdatedDate__wz6_B"};